import request, { ResponsePageableData } from '@/libs/request'

/** 早餐订单 */
export const getOrderList = (data?) => request<ResponsePageableData>({ url: 'adminapi/OrderBreakfast/getOrderList?sort_key=created_at', data })
